import store from "@/state/store";
// Partner-átjáró kezelő — külön pakk (`src/apihub/`), hogy egyben mozogjon: az adatai NEM a
// mi API-nkból jönnek, hanem az apihubból, saját klienssel és hitelesítéssel.
import apihubRoutes from "@/apihub/routes";

export default [
    {
        path: "/",
        name: "home",
        meta: {
            authRequired: true,
            translate: (t) => {
                return t('menu_points.home').ucFirst();
            },
        },
        component: () => import("../views/layouts/vertical.vue"),
        children: [
            // =========================
            // PROFILES
            // =========================

            {
                path: 'profiles',
                name: 'profiles',
                component: () => import('../views/helpers/grouper/grouper.vue'),
                meta: {
                    translate: (t) => t('menu_points.profiles').ucFirst()
                },
                redirect: { name: 'profiles-list' },
                children: [
                    {
                        path: '',
                        name: 'profiles-list',
                        meta: {
                            translate: (t) => t('menu_points.profiles').ucFirst()
                        },
                        component: () => import('../views/pages/profiles/list.vue'),
                    },
                    {
                        path: 'me',
                        name: 'profiles-edit',
                        meta: {
                            translate: (t) => t('base.edit_item', {item: t('base.profile')}).ucFirst(),
                            // a saját profil minden belépett felhasználóé: nincs hozzá menüpont, tehát menüpont-jog sem
                            ownProfile: true,
                        },
                        component: () => import('../views/pages/profiles/edit.vue'),
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'profiles-show',
                        meta: {
                            translate: (t) => t('base.show_item', {item: t('base.profile')}).ucFirst()
                        },
                        component: () => import('../views/pages/profiles/show.vue'),
                    },
                ]
            },

            // =========================
            // APPLICATION
            // =========================

            {
                path: 'application',
                name: 'application',
                component: () => import('../views/helpers/grouper/grouper.vue'),
                meta: {
                    translate: (t) => t('menu_points.application').ucFirst(),
                    type: 'tenant'
                },
                children: [

                    // Dashboard
                    {
                        path: 'dashboard',
                        name: 'application-dashboard',
                        meta: {
                            translate: (t) => t('menu_points.application_dashboard').ucFirst()
                        },
                        component: () => import("../views/pages/empty.vue"),
                    },

                    // Páciensek
                    {
                        path: 'patients',
                        name: 'application-patients',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.application_patients').ucFirst()
                        },
                        children: [
                            {
                                path: 'patients',
                                name: 'application-patients-patients',
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                meta: {
                                    translate: (t) => t('menu_points.application_patients_patients').ucFirst()
                                },
                                redirect: { name: 'application-patients-patients-list' },
                                children: [
                                    {
                                        path: '',
                                        name: 'application-patients-patients-list',
                                        meta: {
                                            translate: (t) => t('menu_points.application_patients_patients').ucFirst()
                                        },
                                        component: () => import('../views/pages/patients/list.vue'),
                                    },
                                    {
                                        path: 'create',
                                        name: 'application-patients-patients-create',
                                        meta: {
                                            translate: (t, tc) => t('base.create_new_item', {item: tc('medical::patients.patient', 1)}).ucFirst()
                                        },
                                        component: () => import('../views/pages/patients/page.vue'),
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'application-patients-patients-edit',
                                        meta: {
                                            translate: (t, tc) => t('base.edit_item', {item: tc('medical::patients.patient', 1)}).ucFirst()
                                        },
                                        component: () => import('../views/pages/patients/page.vue'),
                                    },
                                ]
                            },
                            {
                                // az intézmény saját páciensei közt, és az intézményhez nem kötött pácienssel (pontos egyezésre)
                                path: 'merge',
                                name: 'application-patients-merge',
                                meta: {
                                    translate: (t) => t('menu_points.application_patients_merge').ucFirst()
                                },
                                component: () => import('../views/pages/patients/merge.vue'),
                            },
                        ]
                    },

                    // Előjegyzések
                    {
                        path: 'appointments',
                        name: 'application-appointments',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.application_appointments').ucFirst()
                        },
                        children: [
                            {
                                path: 'appointments',
                                name: 'application-appointments-appointments',
                                meta: {
                                    translate: (t) => t('menu_points.application_appointments_appointments').ucFirst()
                                },
                                component: () => import("../views/pages/bookings/calendar.vue"),
                            },
                            {
                                path: 'my-appointments',
                                name: 'application-appointments-my-appointments',
                                meta: {
                                    translate: (t) => t('menu_points.application_appointments_my_appointments').ucFirst()
                                },
                                component: () => import("../views/pages/bookings/calendar.vue"),
                                props: { onlyMine: true },
                            },
                            {
                                path: 'waiting-list',
                                name: 'application-appointments-waiting-list',
                                meta: {
                                    translate: (t) => t('menu_points.application_appointments_waiting_list').ucFirst()
                                },
                                component: () => import("../views/pages/waitingList/index.vue"),
                            },
                            {
                                path: 'without-doctor',
                                name: 'application-appointments-without-doctor',
                                meta: {
                                    translate: (t) => t('menu_points.application_appointments_without_doctor').ucFirst()
                                },
                                component: () => import("../views/pages/bookings/without-doctor.vue"),
                            }
                        ]
                    },

                    // Rendelési idők
                    {
                        path: 'schedules',
                        name: 'application-schedules',
                        component: () => import('../views/helpers/schedule-tenant-wrapper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.application_schedules').ucFirst()
                        },
                        children: [
                            // Rendelési idők (tenant-szűrve)
                            {
                                path: 'schedules',
                                name: 'application-schedules-schedules',
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'application-schedules-schedules-list' },
                                meta: {
                                    translate: (t) => t('menu_points.application_schedules_schedules').ucFirst()
                                },
                                children: [
                                    {
                                        path: '',
                                        name: 'application-schedules-schedules-list',
                                        meta: {
                                            translate: (t) => t('menu_points.application_schedules_schedules').ucFirst()
                                        },
                                        component: () => import('../views/pages/consultingPeriods/list.vue'),
                                        props: {
                                            ownTenant: true,
                                            createRouteName: 'application-schedules-schedules-create',
                                            editRouteName: 'application-schedules-schedules-edit'
                                        }
                                    },
                                    {
                                        path: 'create',
                                        name: 'application-schedules-schedules-create',
                                        meta: {
                                            translate: (t, tc) => t('base.create_new_item', {item: tc('medical::consulting_periods.consulting_period', 1)}).ucFirst()
                                        },
                                        component: () => import('../views/pages/consultingPeriods/page.vue'),
                                        props: { ownTenant: true, baseRoutePath: '/application/schedules/schedules' }
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'application-schedules-schedules-edit',
                                        meta: {
                                            translate: (t, tc) => t('base.edit_item', {item: tc('medical::consulting_periods.consulting_period', 1)}).ucFirst()
                                        },
                                        component: () => import('../views/pages/consultingPeriods/page.vue'),
                                        props: { ownTenant: true, baseRoutePath: '/application/schedules/schedules' }
                                    },
                                ]
                            },
                            // Rendelői szünnapok (tenant-szűrve, user_id NULL)
                            {
                                path: 'holidays',
                                name: 'application-schedules-holidays',
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'application-schedules-holidays-list' },
                                meta: {
                                    translate: (t) => t('menu_points.application_schedules_holidays').ucFirst()
                                },
                                children: [
                                    {
                                        path: '',
                                        name: 'application-schedules-holidays-list',
                                        meta: {
                                            translate: (t) => t('menu_points.application_schedules_holidays').ucFirst()
                                        },
                                        component: () => import('../views/pages/consultingCloses/list.vue'),
                                        props: {
                                            ownTenant: true,
                                            userFilter: 'null',
                                            createRouteName: 'application-schedules-holidays-create',
                                            editRouteName: 'application-schedules-holidays-edit',
                                            titleKey: 'menu_points.application_schedules_holidays'
                                        }
                                    },
                                    {
                                        path: 'create',
                                        name: 'application-schedules-holidays-create',
                                        meta: {
                                            translate: (t, tc) => t('base.create_new_item', {item: tc('medical::consulting_closes.consulting_close', 1)}).ucFirst()
                                        },
                                        component: () => import('../views/pages/consultingCloses/page.vue'),
                                        props: {
                                            ownTenant: true,
                                            forceNullUser: true,
                                            baseRoutePath: '/application/schedules/holidays',
                                            titleKey: 'medical::consulting_closes.consulting_close'
                                        }
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'application-schedules-holidays-edit',
                                        meta: {
                                            translate: (t, tc) => t('base.edit_item', {item: tc('medical::consulting_closes.consulting_close', 1)}).ucFirst()
                                        },
                                        component: () => import('../views/pages/consultingCloses/page.vue'),
                                        props: {
                                            ownTenant: true,
                                            forceNullUser: true,
                                            baseRoutePath: '/application/schedules/holidays',
                                            titleKey: 'medical::consulting_closes.consulting_close'
                                        }
                                    },
                                ]
                            },
                            // Orvos szabadnapok (tenant-szűrve, user_id NOT NULL)
                            {
                                path: 'doctors-holidays',
                                name: 'application-schedules-doctors-holidays',
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'application-schedules-doctors-holidays-list' },
                                meta: {
                                    translate: (t) => t('menu_points.application_schedules_doctors_holidays').ucFirst()
                                },
                                children: [
                                    {
                                        path: '',
                                        name: 'application-schedules-doctors-holidays-list',
                                        meta: {
                                            translate: (t) => t('menu_points.application_schedules_doctors_holidays').ucFirst()
                                        },
                                        component: () => import('../views/pages/consultingCloses/list.vue'),
                                        props: {
                                            ownTenant: true,
                                            userFilter: 'not_null',
                                            createRouteName: 'application-schedules-doctors-holidays-create',
                                            editRouteName: 'application-schedules-doctors-holidays-edit',
                                            titleKey: 'menu_points.application_schedules_doctors_holidays'
                                        }
                                    },
                                    {
                                        path: 'create',
                                        name: 'application-schedules-doctors-holidays-create',
                                        meta: {
                                            translate: (t, tc) => t('base.create_new_item', {item: tc('medical::consulting_closes.consulting_close', 1)}).ucFirst()
                                        },
                                        component: () => import('../views/pages/consultingCloses/page.vue'),
                                        props: {
                                            ownTenant: true,
                                            baseRoutePath: '/application/schedules/doctors-holidays',
                                            titleKey: 'medical::consulting_closes.consulting_close'
                                        }
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'application-schedules-doctors-holidays-edit',
                                        meta: {
                                            translate: (t, tc) => t('base.edit_item', {item: tc('medical::consulting_closes.consulting_close', 1)}).ucFirst()
                                        },
                                        component: () => import('../views/pages/consultingCloses/page.vue'),
                                        props: {
                                            ownTenant: true,
                                            baseRoutePath: '/application/schedules/doctors-holidays',
                                            titleKey: 'medical::consulting_closes.consulting_close'
                                        }
                                    },
                                ]
                            },
                            // Rendelési idő kategóriák (tenant-szűrve)
                            {
                                path: 'categories',
                                name: 'application-schedules-categories',
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'application-schedules-categories-list' },
                                meta: {
                                    translate: (t) => t('menu_points.application_schedules_categories').ucFirst()
                                },
                                children: [
                                    {
                                        path: '',
                                        name: 'application-schedules-categories-list',
                                        meta: {
                                            translate: (t) => t('menu_points.application_schedules_categories').ucFirst()
                                        },
                                        component: () => import('../views/pages/consultingCategories/list.vue'),
                                        props: {
                                            ownTenant: true,
                                            createRouteName: 'application-schedules-categories-create',
                                            editRouteName: 'application-schedules-categories-edit'
                                        }
                                    },
                                    {
                                        path: 'create',
                                        name: 'application-schedules-categories-create',
                                        meta: {
                                            translate: (t, tc) => t('base.create_new_item', {item: tc('medical::consultingCategories.consultingCategory', 1)}).ucFirst()
                                        },
                                        component: () => import('../views/pages/consultingCategories/page.vue'),
                                        props: { ownTenant: true, baseRoutePath: '/application/schedules/categories' }
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'application-schedules-categories-edit',
                                        meta: {
                                            translate: (t, tc) => t('base.edit_item', {item: tc('medical::consultingCategories.consultingCategory', 1)}).ucFirst()
                                        },
                                        component: () => import('../views/pages/consultingCategories/page.vue'),
                                        props: { ownTenant: true, baseRoutePath: '/application/schedules/categories' }
                                    },
                                ]
                            },
                            // Recepciók, szobák (tenant-szűrve)
                            {
                                path: 'rooms',
                                name: 'application-schedules-rooms',
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'application-schedules-rooms-list' },
                                meta: {
                                    translate: (t) => t('menu_points.application_schedules_rooms').ucFirst()
                                },
                                children: [
                                    {
                                        path: '',
                                        name: 'application-schedules-rooms-list',
                                        meta: {
                                            translate: (t) => t('menu_points.application_schedules_rooms').ucFirst()
                                        },
                                        component: () => import('../views/pages/rooms/list.vue'),
                                        props: {
                                            ownTenant: true,
                                            createRouteName: 'application-schedules-rooms-create',
                                            editRouteName: 'application-schedules-rooms-edit'
                                        }
                                    },
                                    {
                                        path: 'create',
                                        name: 'application-schedules-rooms-create',
                                        meta: {
                                            translate: (t, tc) => t('base.create_new_item', {item: tc('medical::rooms.room', 1)}).ucFirst()
                                        },
                                        component: () => import('../views/pages/rooms/page.vue'),
                                        props: { ownTenant: true, baseRoutePath: '/application/schedules/rooms' }
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'application-schedules-rooms-edit',
                                        meta: {
                                            translate: (t, tc) => t('base.edit_item', {item: tc('medical::rooms.room', 1)}).ucFirst()
                                        },
                                        component: () => import('../views/pages/rooms/page.vue'),
                                        props: { ownTenant: true, baseRoutePath: '/application/schedules/rooms' }
                                    },
                                ]
                            }
                        ]
                    },

                    // Felhasználók
                    {
                        path: 'users',
                        name: 'application-users',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.application_users').ucFirst()
                        },
                        children: [
                            {
                                path: 'nurses',
                                name: 'application-users-nurses',
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'application-users-nurses-list' },
                                meta: {
                                    translate: (t) => t('menu_points.application_users_nurses').ucFirst()
                                },
                                children: [
                                    {
                                        path: '',
                                        name: 'application-users-nurses-list',
                                        meta: {
                                            translate: (t) => t('menu_points.application_users_nurses').ucFirst()
                                        },
                                        component: () => import('../views/pages/system/users/list.vue'),
                                        props: {
                                            userType: 'staff',
                                            tenantScoped: true,
                                            createRouteName: 'application-users-nurses-create',
                                            editRouteName: 'application-users-nurses-edit',
                                            titleKey: 'menu_points.application_users_nurses'
                                        }
                                    },
                                    {
                                        path: 'create',
                                        name: 'application-users-nurses-create',
                                        meta: {
                                            translate: (t, tc) => t('base.create_new_item', {item: tc('menu_points.application_users_nurses', 1)}).ucFirst()
                                        },
                                        component: () => import('../views/pages/system/users/item.vue'),
                                        props: {
                                            defaultUserType: 'staff',
                                            listRouteName: 'application-users-nurses-list',
                                            editRouteName: 'application-users-nurses-edit'
                                        }
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'application-users-nurses-edit',
                                        meta: {
                                            translate: (t, tc) => t('base.edit_item', {item: tc('menu_points.application_users_nurses', 1)}).ucFirst()
                                        },
                                        component: () => import('../views/pages/system/users/item.vue'),
                                        props: {
                                            listRouteName: 'application-users-nurses-list',
                                            editRouteName: 'application-users-nurses-edit'
                                        }
                                    },
                                ]
                            },
                            {
                                path: 'doctors',
                                name: 'application-users-doctors',
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'application-users-doctors-list' },
                                meta: {
                                    translate: (t) => t('menu_points.application_users_doctors').ucFirst()
                                },
                                children: [
                                    {
                                        path: '',
                                        name: 'application-users-doctors-list',
                                        meta: {
                                            translate: (t) => t('menu_points.application_users_doctors').ucFirst()
                                        },
                                        component: () => import('../views/pages/system/users/list.vue'),
                                        props: {
                                            userType: 'medical',
                                            tenantScoped: true,
                                            createRouteName: 'application-users-doctors-create',
                                            editRouteName: 'application-users-doctors-edit',
                                            titleKey: 'menu_points.application_users_doctors'
                                        }
                                    },
                                    {
                                        path: 'create',
                                        name: 'application-users-doctors-create',
                                        meta: {
                                            translate: (t, tc) => t('base.create_new_item', {item: tc('menu_points.application_users_doctors', 1)}).ucFirst()
                                        },
                                        component: () => import('../views/pages/system/users/item.vue'),
                                        props: {
                                            defaultUserType: 'medical',
                                            listRouteName: 'application-users-doctors-list',
                                            editRouteName: 'application-users-doctors-edit'
                                        }
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'application-users-doctors-edit',
                                        meta: {
                                            translate: (t, tc) => t('base.edit_item', {item: tc('menu_points.application_users_doctors', 1)}).ucFirst()
                                        },
                                        component: () => import('../views/pages/system/users/item.vue'),
                                        props: {
                                            listRouteName: 'application-users-doctors-list',
                                            editRouteName: 'application-users-doctors-edit'
                                        }
                                    },
                                ]
                            },
                            {
                                path: 'users',
                                name: 'application-users-users',
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'application-users-users-list' },
                                meta: {
                                    translate: (t) => t('menu_points.application_users_users').ucFirst()
                                },
                                children: [
                                    {
                                        path: '',
                                        name: 'application-users-users-list',
                                        meta: {
                                            translate: (t) => t('menu_points.application_users_users').ucFirst()
                                        },
                                        component: () => import('../views/pages/system/users/list.vue'),
                                        props: {
                                            tenantScoped: true,
                                            createRouteName: 'application-users-users-create',
                                            editRouteName: 'application-users-users-edit',
                                            titleKey: 'menu_points.application_users_users'
                                        }
                                    },
                                    {
                                        path: 'create',
                                        name: 'application-users-users-create',
                                        meta: {
                                            translate: (t, tc) => t('base.create_new_item', {item: tc('menu_points.application_users_users', 1)}).ucFirst()
                                        },
                                        component: () => import('../views/pages/system/users/item.vue'),
                                        props: {
                                            defaultUserType: 'regular',
                                            listRouteName: 'application-users-users-list',
                                            editRouteName: 'application-users-users-edit'
                                        }
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'application-users-users-edit',
                                        meta: {
                                            translate: (t, tc) => t('base.edit_item', {item: tc('menu_points.application_users_users', 1)}).ucFirst()
                                        },
                                        component: () => import('../views/pages/system/users/item.vue'),
                                        props: {
                                            listRouteName: 'application-users-users-list',
                                            editRouteName: 'application-users-users-edit'
                                        }
                                    },
                                ]
                            }
                        ]
                    },

                    // Elszámolásaim (orvos saját nézete, elszámolóház F7)
                    {
                        path: 'my-settlements',
                        name: 'application-my-settlements',
                        meta: {
                            translate: (t) => t('menu_points.application_my_settlements').ucFirst()
                        },
                        component: () => import('../views/pages/reports/my-settlements.vue'),
                    },

                    // Elszámolóház intézményi szinten: ugyanazok a listák, a felhasználó saját intézményeire
                    {
                        path: 'clearing-house',
                        name: 'application-clearing-house',
                        meta: {
                            translate: (t) => t('menu_points.application_clearing_house').ucFirst()
                        },
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        redirect: { name: 'application-used-services-list' },
                        children: [
                            {
                                path: 'used-services',
                                name: 'application-clearing-house-used-services',
                                meta: {
                                    translate: (t) => t('menu_points.system_clearing_house_used_services').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'application-used-services-list' },
                                children: [
                                    {
                                        path: '',
                                        name: 'application-used-services-list',
                                        meta: {
                                            translate: (t) => t('menu_points.system_clearing_house_used_services').ucFirst()
                                        },
                                        component: () => import('../views/pages/usedServices/list.vue')
                                    },
                                ]
                            },
                            {
                                path: 'invoices',
                                name: 'application-clearing-house-invoices',
                                meta: {
                                    translate: (t) => t('menu_points.system_clearing_house_invoices').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'application-invoices-list' },
                                children: [
                                    {
                                        path: '',
                                        name: 'application-invoices-list',
                                        meta: {
                                            translate: (t) => t('menu_points.system_clearing_house_invoices').ucFirst()
                                        },
                                        component: () => import('../views/pages/invoices/list.vue')
                                    },
                                ]
                            },
                            {
                                path: 'payments',
                                name: 'application-clearing-house-payments',
                                meta: {
                                    translate: (t) => t('menu_points.system_clearing_house_payments').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'application-payments-list' },
                                children: [
                                    {
                                        path: '',
                                        name: 'application-payments-list',
                                        meta: {
                                            translate: (t) => t('menu_points.system_clearing_house_payments').ucFirst()
                                        },
                                        component: () => import('../views/pages/payments/list.vue')
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'application-payments-payment-show',
                                        meta: {
                                            translate: (t) => t('financial::payments.detail.title').ucFirst()
                                        },
                                        component: () => import('../views/pages/payments/page.vue')
                                    },
                                ]
                            },
                        ]
                    },

                    // Riportok
                    {
                        path: 'reports',
                        name: 'application-reports',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.application_reports').ucFirst()
                        },
                        children: [
                            {
                                path: 'financial',
                                name: 'application-reports-financial',
                                meta: {
                                    translate: (t) => t('menu_points.application_reports_financial').ucFirst()
                                },
                                component: () => import("../views/pages/reports/financial.vue"),
                            },
                            {
                                path: 'feedback',
                                name: 'application-reports-feedback',
                                meta: {
                                    translate: (t) => t('menu_points.application_reports_feedback').ucFirst()
                                },
                                component: () => import("../views/pages/reports/feedback.vue"),
                                props: { ownTenant: true },
                            },
                            {
                                path: 'cancellations',
                                name: 'application-reports-cancellations',
                                meta: {
                                    translate: (t) => t('menu_points.application_reports_cancellations').ucFirst()
                                },
                                component: () => import("../views/pages/reports/cancellations.vue"),
                                props: { ownTenant: true },
                            },
                            {
                                path: 'marketing',
                                name: 'application-reports-marketing',
                                meta: {
                                    translate: (t) => t('menu_points.application_reports_marketing').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'patient',
                                name: 'application-reports-patient',
                                meta: {
                                    translate: (t) => t('menu_points.application_reports_patient').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'custom',
                                name: 'application-reports-custom',
                                meta: {
                                    translate: (t) => t('menu_points.application_reports_custom').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'system',
                                name: 'application-reports-system',
                                meta: {
                                    translate: (t) => t('menu_points.application_reports_system').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            }
                        ]
                    },

                    // Jogosultságkezelés
                    {
                        path: 'permissions',
                        name: 'application-permissions',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.application_permissions').ucFirst()
                        },
                        children: [
                            {
                                path: 'management',
                                name: 'application-permissions-management',
                                meta: {
                                    translate: (t) => t('menu_points.application_permission_management').ucFirst()
                                },
                                component: () => import("../views/helpers/grouper/grouper.vue"),
                                redirect: { name: 'application-role-groups-list' },
                                children: [
                                    {
                                        path: 'role-groups',
                                        name: 'application-role-groups',
                                        meta: {
                                            translate: (t) => t('menu_points.application_permission_management_role_groups').ucFirst(),
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'application-role-groups-list' },
                                        children: [
                                            {
                                                path: '',
                                                name: 'application-role-groups-list',
                                                props: { ownTenant: true },
                                                meta: {
                                                    translate: (t) => t('menu_points.application_permission_management_role_groups').ucFirst(),
                                                },
                                                component: () => import('../views/pages/system/authorization/role-groups/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'application-role-group-create',
                                                props: { ownTenant: true },
                                                meta: {
                                                    translate: (t, tc) =>
                                                        t('base.create_new_item', { item: tc('authorization::role_groups.role_group', 1) }).ucFirst(),
                                                },
                                                component: () => import('../views/pages/system/authorization/role-groups/item.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'application-role-group-edit',
                                                props: { ownTenant: true },
                                                meta: {
                                                    translate: (t, tc) =>
                                                        t('base.edit_item', { item: tc('authorization::role_groups.role_group', 1) }).ucFirst(),
                                                },
                                                component: () => import('../views/pages/system/authorization/role-groups/item.vue')
                                            },
                                        ]
                                    },
                                ]
                            }
                        ]
                    },

                    // Együttműködések
                    {
                        path: 'partnerships',
                        name: 'application-partnerships',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.application_partnerships').ucFirst()
                        },
                        children: [
                            {
                                path: 'companies',
                                name: 'application-partnerships-companies',
                                meta: {
                                    translate: (t) => t('menu_points.application_partnerships_companies').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'companies-list' },
                                children: [
                                    {
                                        path: '',
                                        name: 'companies-list',
                                        meta: {
                                            translate: (t) => t('menu_points.application_partnerships_companies').ucFirst()
                                        },
                                        component: () => import('../views/pages/partnership/companies/list.vue'),
                                    },
                                    {
                                        path: 'create',
                                        name: 'companies-company-create',
                                        meta: {
                                            translate: (t) => t('base.create').ucFirst()
                                        },
                                        component: () => import('../views/pages/partnership/companies/page.vue'),
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'companies-company-edit',
                                        meta: {
                                            translate: (t) => t('base.edit').ucFirst()
                                        },
                                        component: () => import('../views/pages/partnership/companies/page.vue'),
                                    },
                                ]
                            },
                            {
                                path: 'contracts',
                                name: 'application-partnerships-contracts',
                                meta: {
                                    translate: (t) => t('menu_points.application_partnerships_contracts').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'contracts-list' },
                                children: [
                                    {
                                        path: '',
                                        name: 'contracts-list',
                                        meta: {
                                            translate: (t) => t('menu_points.application_partnerships_contracts').ucFirst()
                                        },
                                        component: () => import('../views/pages/partnership/contracts/list.vue'),
                                    },
                                    {
                                        path: 'create',
                                        name: 'contracts-contract-create',
                                        meta: {
                                            translate: (t) => t('base.create').ucFirst()
                                        },
                                        component: () => import('../views/pages/partnership/contracts/page.vue'),
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'contracts-contract-edit',
                                        meta: {
                                            translate: (t) => t('base.edit').ucFirst()
                                        },
                                        component: () => import('../views/pages/partnership/contracts/page.vue'),
                                    },
                                ]
                            },
                            {
                                path: 'contract-bookings',
                                name: 'application-partnerships-contract-bookings',
                                meta: {
                                    translate: (t) => t('menu_points.application_partnerships_contractBookings').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'contractBookings-list' },
                                children: [
                                    {
                                        path: '',
                                        name: 'contractBookings-list',
                                        meta: {
                                            translate: (t) => t('menu_points.application_partnerships_contractBookings').ucFirst()
                                        },
                                        component: () => import('../views/pages/partnership/contractBookings/list.vue'),
                                    },
                                    {
                                        path: 'create',
                                        name: 'contractBookings-contractBooking-create',
                                        meta: {
                                            translate: (t) => t('base.create').ucFirst()
                                        },
                                        component: () => import('../views/pages/partnership/contractBookings/page.vue'),
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'contractBookings-contractBooking-edit',
                                        meta: {
                                            translate: (t) => t('base.edit').ucFirst()
                                        },
                                        component: () => import('../views/pages/partnership/contractBookings/page.vue'),
                                    },
                                ]
                            },
                            {
                                path: 'contract-employees',
                                name: 'application-partnerships-contract-employees',
                                meta: {
                                    translate: (t) => t('menu_points.application_partnerships_contractEmployees').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'contractEmployees-list' },
                                children: [
                                    {
                                        path: '',
                                        name: 'contractEmployees-list',
                                        meta: {
                                            translate: (t) => t('menu_points.application_partnerships_contractEmployees').ucFirst()
                                        },
                                        component: () => import('../views/pages/partnership/contractEmployees/list.vue'),
                                    },
                                    {
                                        path: 'create',
                                        name: 'contractEmployees-contractEmployee-create',
                                        meta: {
                                            translate: (t) => t('base.create').ucFirst()
                                        },
                                        component: () => import('../views/pages/partnership/contractEmployees/page.vue'),
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'contractEmployees-contractEmployee-edit',
                                        meta: {
                                            translate: (t) => t('base.edit').ucFirst()
                                        },
                                        component: () => import('../views/pages/partnership/contractEmployees/page.vue'),
                                    },
                                ]
                            },
                            {
                                path: 'contract-waiting-lists',
                                name: 'application-partnerships-contract-waiting-lists',
                                meta: {
                                    translate: (t) => t('menu_points.application_partnerships_contractWaitingLists').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'contractWaitingLists-list' },
                                children: [
                                    {
                                        path: '',
                                        name: 'contractWaitingLists-list',
                                        meta: {
                                            translate: (t) => t('menu_points.application_partnerships_contractWaitingLists').ucFirst()
                                        },
                                        component: () => import('../views/pages/partnership/contractWaitingLists/list.vue'),
                                    },
                                    {
                                        path: 'create',
                                        name: 'contractWaitingLists-contractWaitingList-create',
                                        meta: {
                                            translate: (t) => t('base.create').ucFirst()
                                        },
                                        component: () => import('../views/pages/partnership/contractWaitingLists/page.vue'),
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'contractWaitingLists-contractWaitingList-edit',
                                        meta: {
                                            translate: (t) => t('base.edit').ucFirst()
                                        },
                                        component: () => import('../views/pages/partnership/contractWaitingLists/page.vue'),
                                    },
                                ]
                            },
                            {
                                path: 'services',
                                name: 'application-partnerships-services',
                                meta: {
                                    translate: (t) => t('menu_points.application_partnerships_services').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'services-list' },
                                children: [
                                    {
                                        path: '',
                                        name: 'services-list',
                                        meta: {
                                            translate: (t) => t('menu_points.application_partnerships_services').ucFirst()
                                        },
                                        component: () => import('../views/pages/partnership/services/list.vue'),
                                    },
                                    {
                                        path: 'create',
                                        name: 'services-service-create',
                                        meta: {
                                            translate: (t) => t('base.create').ucFirst()
                                        },
                                        component: () => import('../views/pages/partnership/services/page.vue'),
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'services-service-edit',
                                        meta: {
                                            translate: (t) => t('base.edit').ucFirst()
                                        },
                                        component: () => import('../views/pages/partnership/services/page.vue'),
                                    },
                                ]
                            },
                            {
                                path: 'export-import',
                                name: 'application-partnerships-export-import',
                                meta: {
                                    translate: (t) => t('menu_points.application_partnerships_export_import').ucFirst()
                                },
                                component: () => import('../views/pages/partnership/importExport/page.vue'),
                            },
                            {
                                path: 'company-reports',
                                name: 'application-partnerships-company-reports',
                                meta: {
                                    translate: (t) => t('menu_points.application_partnerships_company_reports').ucFirst()
                                },
                                component: () => import('../views/pages/partnership/reports/page.vue'),
                            },
                        ]
                    }
                ]
            },

            // =========================
            // MASTER DATA
            // =========================
            {
                path: 'master-data',
                name: 'master-data',
                component: () => import('../views/helpers/grouper/grouper.vue'),
                meta: {
                    translate: (t) => t('menu_points.master_data').ucFirst(),
                    type: 'tenant'
                },
                children: [
                    // Kérdőívek
                    {
                        path: 'questionnaires',
                        name: 'master-data-questionnaires',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.master_data_questionnaires').ucFirst()
                        },
                        children: [
                            {
                                path: 'patient-satisfaction',
                                name: 'master-data-questionnaires-patient-satisfaction',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_questionnaires_patient_satisfaction').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'master-data-questionnaires-patient-satisfaction-list'},
                                children: [
                                    {
                                        path: '',
                                        name: 'master-data-questionnaires-patient-satisfaction-list',
                                        meta: {
                                            translate: (t) => t('menu_points.master_data_questionnaires_patient_satisfaction').ucFirst()
                                        },
                                        props: {type: 'feedback'},
                                        component: () => import('../views/pages/forms/list.vue')
                                    },
                                    {
                                        path: 'create',
                                        name: 'master-data-questionnaires-patient-satisfaction-create',
                                        meta: {
                                            translate: (t) => t('base.create').ucFirst(),
                                        },
                                        props: {type: 'feedback'},
                                        component: () => import('../views/pages/forms/page.vue')
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'master-data-questionnaires-patient-satisfaction-edit',
                                        meta: {
                                            translate: (t) => t('base.edit').ucFirst(),
                                        },
                                        props: {type: 'feedback'},
                                        component: () => import('../views/pages/forms/page.vue')
                                    },
                                ]
                            },
                            {
                                path: 'status-assessment',
                                name: 'master-data-questionnaires-status-assessment',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_questionnaires_status_assessment').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'master-data-questionnaires-status-assessment-list'},
                                children: [
                                    {
                                        path: '',
                                        name: 'master-data-questionnaires-status-assessment-list',
                                        meta: {
                                            translate: (t) => t('menu_points.master_data_questionnaires_status_assessment').ucFirst()
                                        },
                                        props: {type: 'services'},
                                        component: () => import('../views/pages/forms/list.vue')
                                    },
                                    {
                                        path: 'create',
                                        name: 'master-data-questionnaires-status-assessment-create',
                                        meta: {
                                            translate: (t) => t('base.create').ucFirst(),
                                        },
                                        props: {type: 'services'},
                                        component: () => import('../views/pages/forms/page.vue')
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'master-data-questionnaires-status-assessment-edit',
                                        meta: {
                                            translate: (t) => t('base.edit').ucFirst(),
                                        },
                                        props: {type: 'services'},
                                        component: () => import('../views/pages/forms/page.vue')
                                    },
                                ]
                            }
                        ]
                    },

                    // Dokumentumok
                    {
                        path: 'documents',
                        name: 'master-data-documents',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.master_data_documents').ucFirst()
                        },
                        children: [
                            {
                                path: 'service-documents',
                                name: 'master-data-documents-service-documents',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_documents_service_documents').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: {name: 'master-data-documents-service-documents-list'},
                                children: [
                                    {
                                        path: '',
                                        name: 'master-data-documents-service-documents-list',
                                        meta: {
                                            translate: (t) => t('menu_points.master_data_documents_service_documents').ucFirst()
                                        },
                                        component: () => import('../views/pages/serviceDocuments/list.vue')
                                    },
                                    {
                                        path: 'create',
                                        name: 'master-data-documents-service-documents-create',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.create_new_item', {item: tc('serviceDocuments.service_document', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/serviceDocuments/page.vue')
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'master-data-documents-service-documents-edit',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.edit_item', {item: tc('serviceDocuments.service_document', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/serviceDocuments/page.vue')
                                    },
                                ]
                            },
                            // A saját intézmény fájltörlési kérelmei (olvasva; a saját kérés visszavonható, dönteni a Rendszer menüben lehet)
                            {
                                path: 'deletion-requests',
                                name: 'master-data-documents-deletion-requests',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_documents_deletion_requests').ucFirst()
                                },
                                component: () => import('../views/pages/patientDocuments/deletion-requests.vue')
                            },
                        ]
                    },

                    // Számlázási törzsadatok
                    {
                        path: 'billing',
                        name: 'master-data-billing',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.master_data_billing').ucFirst()
                        },
                        children: [
                            {
                                path: 'customer-card-types',
                                name: 'master-data-billing-customer-card-types',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_billing_customer_card_types').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'tenant-service-groups',
                                name: 'master-data-billing-tenant-service-groups',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_billing_tenant_service_groups').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'master-data-billing-tenant-service-groups-list'},
                                children: [
                                    {
                                        path: '',
                                        name: 'master-data-billing-tenant-service-groups-list',
                                        meta: {
                                            translate: (t) => t('menu_points.master_data_billing_tenant_service_groups').ucFirst()
                                        },
                                        component: () => import('../views/pages/tenantServiceGroups/list.vue')
                                    },
                                    {
                                        path: 'create',
                                        name: 'master-data-billing-tenant-service-groups-create',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.create_new_item', {item: tc('medical::tenantServiceGroups.tenant_service_group', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/tenantServiceGroups/page.vue')
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'master-data-billing-tenant-service-groups-edit',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.edit_item', {item: tc('medical::tenantServiceGroups.tenant_service_group', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/tenantServiceGroups/page.vue')
                                    },
                                ]
                            },
                            {
                                path: 'tenant-services',
                                name: 'master-data-billing-tenant-services',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_billing_tenant_services').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'master-data-billing-tenant-services-list'},
                                children: [
                                    {
                                        path: '',
                                        name: 'master-data-billing-tenant-services-list',
                                        meta: {
                                            translate: (t) => t('menu_points.master_data_billing_tenant_services').ucFirst()
                                        },
                                        component: () => import('../views/pages/tenantServices/list.vue')
                                    },
                                    {
                                        path: 'create',
                                        name: 'master-data-billing-tenant-services-create',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.create_new_item', {item: tc('medical::tenantServices.tenant_service', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/tenantServices/page.vue')
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'master-data-billing-tenant-services-edit',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.edit_item', {item: tc('medical::tenantServices.tenant_service', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/tenantServices/page.vue')
                                    },
                                ]
                            },
                            {
                                path: 'coupons',
                                name: 'master-data-billing-coupons',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_billing_coupons').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'master-data-billing-coupons-list'},
                                children: [
                                    {
                                        path: '',
                                        name: 'master-data-billing-coupons-list',
                                        meta: {
                                            translate: (t) => t('menu_points.master_data_billing_coupons').ucFirst()
                                        },
                                        component: () => import('../views/pages/coupons/list.vue')
                                    },
                                    {
                                        path: 'create',
                                        name: 'master-data-billing-coupons-create',
                                        meta: {
                                            // az Utalványok fülről (kind=voucher) utalvány a címben is
                                            translate: (t, tc, route) => {
                                                return t('base.create_new_item', {item: tc(route?.query?.kind === 'voucher' ? 'financial::coupons.voucher' : 'financial::coupons.coupon', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/coupons/page.vue')
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'master-data-billing-coupons-edit',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.edit_item', {item: tc('financial::coupons.coupon', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/coupons/page.vue')
                                    },
                                    {
                                        path: ':id(\\d+)/codes',
                                        name: 'master-data-billing-coupons-codes',
                                        meta: {
                                            translate: (t) => t('financial::coupons.codes.title').ucFirst(),
                                        },
                                        component: () => import('../views/pages/coupons/codes.vue')
                                    },
                                ]
                            }
                        ]
                    },

                    // Rendelési törzsadatok
                    {
                        path: 'schedules',
                        name: 'master-data-schedules',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.master_data_schedules').ucFirst()
                        },
                        children: [
                            {
                                path: 'schedules',
                                name: 'master-data-schedules-schedules',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_schedules_schedules').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'master-data-schedules-schedules-list'},
                                children: [
                                    {
                                        path: '',
                                        name: 'master-data-schedules-schedules-list',
                                        meta: {
                                            translate: (t) => t('menu_points.master_data_schedules_schedules').ucFirst()
                                        },
                                        component: () => import('../views/pages/consultingPeriods/list.vue')
                                    },
                                    {
                                        path: 'create',
                                        name: 'master-data-schedules-schedules-create',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.create_new_item', {item: tc('medical::consulting_periods.consulting_period', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/consultingPeriods/page.vue')
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'master-data-schedules-schedules-edit',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.edit_item', {item: tc('medical::consulting_periods.consulting_period', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/consultingPeriods/page.vue')
                                    },
                                ]
                            },
                            {
                                path: 'holidays',
                                name: 'master-data-schedules-holidays',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_schedules_holidays').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'master-data-schedules-holidays-list'},
                                children: [
                                    {
                                        path: '',
                                        name: 'master-data-schedules-holidays-list',
                                        meta: {
                                            translate: (t) => t('menu_points.master_data_schedules_holidays').ucFirst()
                                        },
                                        component: () => import('../views/pages/consultingCloses/list.vue'),
                                        props: {
                                            createRouteName: 'master-data-schedules-holidays-create',
                                            editRouteName: 'master-data-schedules-holidays-edit',
                                            userFilter: 'null',
                                            titleKey: 'menu_points.master_data_schedules_holidays'
                                        }
                                    },
                                    {
                                        path: 'create',
                                        name: 'master-data-schedules-holidays-create',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.create_new_item', {item: tc('medical::consulting_closes.consulting_close', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/consultingCloses/page.vue'),
                                        props: {
                                            baseRoutePath: '/master-data/schedules/holidays',
                                            titleKey: 'medical::consulting_closes.consulting_close',
                                            forceNullUser: true
                                        }
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'master-data-schedules-holidays-edit',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.edit_item', {item: tc('medical::consulting_closes.consulting_close', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/consultingCloses/page.vue'),
                                        props: {
                                            baseRoutePath: '/master-data/schedules/holidays',
                                            titleKey: 'medical::consulting_closes.consulting_close',
                                            forceNullUser: true
                                        }
                                    },
                                ]
                            },
                            {
                                path: 'doctors-holidays',
                                name: 'master-data-schedules-doctors-holidays',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_schedules_doctors_holidays').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'master-data-schedules-doctors-holidays-list'},
                                children: [
                                    {
                                        path: '',
                                        name: 'master-data-schedules-doctors-holidays-list',
                                        meta: {
                                            translate: (t) => t('menu_points.master_data_schedules_doctors_holidays').ucFirst()
                                        },
                                        component: () => import('../views/pages/consultingCloses/list.vue'),
                                        props: {
                                            createRouteName: 'master-data-schedules-doctors-holidays-create',
                                            editRouteName: 'master-data-schedules-doctors-holidays-edit',
                                            userFilter: 'not_null',
                                            titleKey: 'menu_points.master_data_schedules_doctors_holidays'
                                        }
                                    },
                                    {
                                        path: 'create',
                                        name: 'master-data-schedules-doctors-holidays-create',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.create_new_item', {item: tc('medical::consulting_closes.consulting_close', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/consultingCloses/page.vue'),
                                        props: {
                                            baseRoutePath: '/master-data/schedules/doctors-holidays',
                                            titleKey: 'medical::consulting_closes.consulting_close'
                                        }
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'master-data-schedules-doctors-holidays-edit',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.edit_item', {item: tc('medical::consulting_closes.consulting_close', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/consultingCloses/page.vue'),
                                        props: {
                                            baseRoutePath: '/master-data/schedules/doctors-holidays',
                                            titleKey: 'medical::consulting_closes.consulting_close'
                                        }
                                    },
                                ]
                            },
                            {
                                path: 'categories',
                                name: 'master-data-schedules-categories',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_schedules_categories').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'consultingCategories-list'},
                                children: [
                                    {
                                        path: '',
                                        name: 'consultingCategories-list',
                                        meta: {
                                            translate: (t) => t('menu_points.master_data_schedules_categories').ucFirst()
                                        },
                                        component: () => import('../views/pages/consultingCategories/list.vue')
                                    },
                                    {
                                        path: 'create',
                                        name: 'consultingCategories-consultingCategory-create',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.create_new_item', {item: tc('medical::consultingCategories.consultingCategory', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/consultingCategories/page.vue')
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'consultingCategories-consultingCategory-edit',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.edit_item', {item: tc('medical::consultingCategories.consultingCategory', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/consultingCategories/page.vue')
                                    },
                                ]
                            },
                            {
                                path: 'online-calendars',
                                name: 'master-data-schedules-online-calendars',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_schedules_online_calendars').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'master-data-schedules-online-calendars-list'},
                                children: [
                                    {
                                        path: '',
                                        name: 'master-data-schedules-online-calendars-list',
                                        meta: {
                                            translate: (t) => t('menu_points.master_data_schedules_online_calendars').ucFirst()
                                        },
                                        component: () => import('../views/pages/onlineCalendars/list.vue')
                                    },
                                    {
                                        path: 'create',
                                        name: 'master-data-schedules-online-calendars-create',
                                        meta: {
                                            translate: (t, tc) => {
                                                        return t('base.create_new_item', {item: tc('medical::onlineCalendars.online_calendar', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/onlineCalendars/page.vue')
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'master-data-schedules-online-calendars-edit',
                                        meta: {
                                            translate: (t, tc) => {
                                                        return t('base.edit_item', {item: tc('medical::onlineCalendars.online_calendar', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/onlineCalendars/page.vue')
                                    },
                                ]
                            },
                            {
                                path: 'tenant-delete-reasons',
                                name: 'master-data-schedules-tenant-delete-reasons',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_schedules_tenant-delete-reasons').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'tenantDeleteReasons-list'},
                                children: [
                                    {
                                        path: '',
                                        name: 'tenantDeleteReasons-list',
                                        meta: {
                                            translate: (t) => t('menu_points.master_data_schedules_tenant-delete-reasons').ucFirst()
                                        },
                                        component: () => import('../views/pages/tenantDeleteReasons/list.vue')
                                    },
                                    {
                                        path: 'create',
                                        name: 'tenantDeleteReasons-tenantDeleteReason-create',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.create_new_item', {item: tc('medical::tenantDeleteReasons.tenantDeleteReason', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/tenantDeleteReasons/page.vue')
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'tenantDeleteReasons-tenantDeleteReason-edit',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.edit_item', {item: tc('medical::tenantDeleteReasons.tenantDeleteReason', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/tenantDeleteReasons/page.vue')
                                    },
                                ]
                            }
                        ]
                    },

                    // Intézmények (törzsadatok tetején; csak a saját/elérhető tenantok — scope-olt, szerkesztés)
                    {
                        path: 'institutions',
                        name: 'master-data-institutions',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.master_data_institutions').ucFirst(),
                        },
                        redirect: { name: 'tenants-list'},
                        children: [
                            {
                                path: '',
                                name: 'tenants-list',
                                meta: {
                                    translate: (t, tc) => {
                                        return tc('system::tenants.tenant', 2).ucFirst();
                                    },
                                },
                                component: () => import('../views/pages/system/tenants/list.vue')
                            },
                            {
                                path: ':id(\\d+)',
                                name: 'tenant-edit',
                                meta: {
                                    translate: (t, tc) => {
                                        return t('base.edit_item', {item: tc('system::tenants.tenant', 1)}).ucFirst();
                                    },
                                },
                                component: () => import('../views/pages/system/tenants/page.vue')
                            },
                        ]
                    },

                    // Szervezeti törzsadatok
                    {
                        path: 'organizations',
                        name: 'master-data-organization',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.master_data_organizations').ucFirst()
                        },
                        children: [
                            {
                                path: 'locations',
                                name: 'master-data-organizations-locations',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_organizations_locations').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'master-data-organizations-locations-list'},
                                children: [
                                    {
                                        path: '',
                                        name: 'master-data-organizations-locations-list',
                                        meta: {
                                            translate: (t) => t('menu_points.master_data_organizations_locations').ucFirst()
                                        },
                                        component: () => import('../views/pages/locations/list.vue')
                                    },
                                    {
                                        path: 'create',
                                        name: 'master-data-organizations-locations-create',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.create_new_item', {item: tc('medical::locations.location', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/locations/page.vue')
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'master-data-organizations-locations-edit',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.edit_item', {item: tc('medical::locations.location', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/locations/page.vue')
                                    },
                                ]
                            },
                            {
                                path: 'departments',
                                name: 'master-data-organizations-departments',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_organizations_departments').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'rooms',
                                name: 'master-data-organizations-rooms',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_organizations_rooms').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'master-data-organizations-rooms-list'},
                                children: [
                                    {
                                        path: '',
                                        name: 'master-data-organizations-rooms-list',
                                        meta: {
                                            translate: (t) => t('menu_points.master_data_organizations_rooms').ucFirst()
                                        },
                                        component: () => import('../views/pages/rooms/list.vue')
                                    },
                                    {
                                        path: 'create',
                                        name: 'master-data-organizations-rooms-create',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.create_new_item', {item: tc('medical::rooms.room', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/rooms/page.vue')
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'master-data-organizations-rooms-edit',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.edit_item', {item: tc('medical::rooms.room', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/rooms/page.vue')
                                    },
                                ]
                            },
                            {
                                path: 'operating-rooms',
                                name: 'master-data-organizations-operating-rooms',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_organizations_operating_rooms').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'master-data-organizations-operating-rooms-list'},
                                // A szobák képernyője, a műtő fajtára rögzítve.
                                children: [
                                    {
                                        path: '',
                                        name: 'master-data-organizations-operating-rooms-list',
                                        meta: {
                                            translate: (t) => t('menu_points.master_data_organizations_operating_rooms').ucFirst()
                                        },
                                        props: {
                                            kind: 'operating',
                                            createRouteName: 'master-data-organizations-operating-rooms-create',
                                            editRouteName: 'master-data-organizations-operating-rooms-edit',
                                        },
                                        component: () => import('../views/pages/rooms/list.vue')
                                    },
                                    {
                                        path: 'create',
                                        name: 'master-data-organizations-operating-rooms-create',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.create_new_item', {item: tc('medical::rooms.operating_room', 1)}).ucFirst();
                                            },
                                        },
                                        props: {kind: 'operating', baseRoutePath: '/master-data/organizations/operating-rooms'},
                                        component: () => import('../views/pages/rooms/page.vue')
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'master-data-organizations-operating-rooms-edit',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.edit_item', {item: tc('medical::rooms.operating_room', 1)}).ucFirst();
                                            },
                                        },
                                        props: {kind: 'operating', baseRoutePath: '/master-data/organizations/operating-rooms'},
                                        component: () => import('../views/pages/rooms/page.vue')
                                    },
                                ]
                            },
                            {
                                path: 'unit-codes',
                                name: 'master-data-organizations-unit-codes',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_organizations_unit_codes').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: {name: 'master-data-organizations-unit-codes-list'},
                                children: [
                                    {
                                        path: '',
                                        name: 'master-data-organizations-unit-codes-list',
                                        component: () => import('../views/pages/tenantUnits/list.vue'),
                                    },
                                    {
                                        path: 'create',
                                        name: 'master-data-organizations-unit-codes-create',
                                        component: () => import('../views/pages/tenantUnits/page.vue'),
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'master-data-organizations-unit-codes-edit',
                                        component: () => import('../views/pages/tenantUnits/page.vue'),
                                    },
                                ],
                            },
                            {
                                path: 'settings',
                                name: 'master-data-organizations-settings',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_organizations_settings').ucFirst()
                                },
                                component: () => import('../views/pages/tenantSettings/page.vue'),
                            },
                            {
                                path: 'communicator',
                                name: 'master-data-organizations-communicator',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_organizations_communicator').ucFirst()
                                },
                                component: () => import('../views/pages/communicator/notification-settings.vue'),
                            }
                        ]
                    }
                ]
            },

            // =========================
            // SYSTEM
            // =========================

            {
                path: 'system',
                name: 'system',
                component: () => import('../views/helpers/grouper/grouper.vue'),
                meta: {
                    translate: (t) => t('menu_points.system').ucFirst(),
                    type: 'global'
                },
                children: [

                    // -------------------------
                    // PARTNER-ÁTJÁRÓ (külön pakk: src/apihub)
                    // -------------------------
                    ...apihubRoutes,

                    // -------------------------
                    // PÁCIENSEK
                    // -------------------------
                    {
                        path: 'patients',
                        name: 'system-patients',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.system_patients').ucFirst()
                        },
                        children: [
                            {
                                path: 'all',
                                name: 'system-patients-all',
                                meta: {
                                    // intézményi adatot mutató Rendszer-lista: belépve, Global állásban olvasva minden intézményé, írva a belépetté
                                    tenantData: true,
                                    translate: (t) => t('menu_points.system_patients_all').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'system-patients-all-list' },
                                children: [
                                    {
                                        path: '',
                                        name: 'system-patients-all-list',
                                        meta: {
                                            translate: (t) => t('menu_points.system_patients_all').ucFirst()
                                        },
                                        // Ugyanaz a lista, mint az Alkalmazás alatt — a hatókört az
                                        // isGlobal adja meg, nem egy második komponens.
                                        props: { isGlobal: true },
                                        component: () => import('../views/pages/patients/list.vue'),
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'system-patients-all-edit',
                                        meta: {
                                            translate: (t, tc) => t('base.edit_item', {item: tc('medical::patients.patient', 1)}).ucFirst()
                                        },
                                        props: { isGlobal: true },
                                        component: () => import('../views/pages/patients/page.vue'),
                                    },
                                    {
                                        // a global admin platform szintű javítása (személyes adatok, indokkal, belépés nélkül)
                                        path: ':id(\\d+)/platform',
                                        name: 'system-patients-all-platform',
                                        meta: {
                                            translate: (t) => t('medical::patients.platform_edit.title').ucFirst()
                                        },
                                        component: () => import('../views/pages/patients/platform-edit.vue'),
                                    },
                                ],
                            },
                            {
                                path: 'merge',
                                name: 'system-patients-merge',
                                meta: {
                                    // intézményi adatot mutató Rendszer-lista: belépve, Global állásban olvasva minden intézményé, írva a belépetté
                                    tenantData: true,
                                    translate: (t) => t('menu_points.system_patients_merge').ucFirst()
                                },
                                component: () => import("../views/pages/patients/merge.vue"),
                            },
                            {
                                // a végleges fájltörlési kérelmek, minden intézményből: a global admin itt dönt, belépés nélkül
                                path: 'deletion-requests',
                                name: 'system-patients-deletion-requests',
                                meta: {
                                    translate: (t) => t('menu_points.system_patients_deletion_requests').ucFirst()
                                },
                                component: () => import('../views/pages/patientDocuments/deletion-requests.vue')
                            },
                        ]
                    },

                    // -------------------------
                    // KOMMUNIKÁCIÓ
                    // -------------------------
                    {
                        path: 'communication',
                        name: 'system-communication',
                        meta: {
                            translate: (t) => t('menu_points.system_communication').ucFirst()
                        },
                        component: () => import('../views/pages/system/communication/index.vue'),
                    },

                    // -------------------------
                    // TÖRZSADATOK
                    // -------------------------
                    {
                        path: 'master-data',
                        name: 'system-master-data',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.system_master_data').ucFirst()
                        },
                        children: [

                            // Globál szolgáltatástörzs
                            {
                                path: 'global-services',
                                name: 'system-master-data-global-services',
                                meta: {
                                    translate: (t) => t('menu_points.system_master_data_global_services').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'system-master-data-global-services-list'},
                                children: [
                                    {
                                        path: '',
                                        name: 'system-master-data-global-services-list',
                                        meta: {
                                            translate: (t) => t('menu_points.system_master_data_global_services').ucFirst()
                                        },
                                        component: () => import('../views/pages/services/list.vue')
                                    },
                                    {
                                        path: 'create',
                                        name: 'system-master-data-global-services-create',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.create_new_item', {item: tc('medical::services.service', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/services/page.vue')
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'system-master-data-global-services-edit',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.edit_item', {item: tc('medical::services.service', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/services/page.vue')
                                    },
                                ]
                            },

                            // -------------------------
                            // CÍMADATOK
                            // A menü/lang aliasok lapos /system/master-data/<x> kulcsot használnak
                            // (address csoportosító szegmens nélkül), ezért a címadat-elemek a
                            // master-data közvetlen gyerekei, hogy a translation_key egyezzen az aliassal.
                            // -------------------------
                                    {
                                        path: "address-types",
                                        name: 'address-types',
                                        component: () => import('../views/helpers/grouper/grouper.vue'), // vagy külön layout
                                        meta: {
                                            translate: (t, tc) => tc('master::address_types.address_type', 2).ucFirst()
                                        },
                                        redirect: { name: 'address-types-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'address-types-list',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return tc('master::address_types.address_type', 2).ucFirst();
                                                    }
                                                },
                                                component: () => import('../views/pages/addresses/address-types/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'address-type-create',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.create_new_item', {item: tc('master::address_types.address_type', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/addresses/address-types/item.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'address-type-edit',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.edit_item', {item: tc('master::address_types.address_type', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/addresses/address-types/item.vue')
                                            },
                                        ]
                                    },
                                    {
                                        path: 'countries',
                                        name: 'countries',
                                        component: () => import('../views/helpers/grouper/grouper.vue'), // vagy külön layout
                                        meta: {
                                            translate: (t, tc) => tc('master::countries.country', 2).ucFirst()
                                        },
                                        redirect: { name: 'countries-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'countries-list',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return tc('master::countries.country', 2).ucFirst();
                                                    }
                                                },
                                                component: () => import('../views/pages/addresses/countries/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'country-create',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.create_new_item', {item: tc('master::countries.country', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/addresses/countries/item.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'country-edit',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.edit_item', {item: tc('master::countries.country', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/addresses/countries/item.vue')
                                            },
                                        ]
                                    },
                                    {
                                        path: 'zip-codes',
                                        name: 'zip-codes',
                                        meta: {
                                            translate: (t, tc) => {
                                                return tc('master::zip_codes.zip_code', 2).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'zip-codes-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'zip-codes-list',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return tc('master::zip_codes.zip_code', 2).ucFirst();
                                                    }
                                                },
                                                component: () => import('../views/pages/addresses/zip-codes/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'zip-code-create',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.create_new_item', {item: tc('master::zip_codes.zip_code', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/addresses/zip-codes/item.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'zip-code-edit',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.edit_item', {item: tc('master::zip_codes.zip_code', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/addresses/zip-codes/item.vue')
                                            },
                                        ]
                                    },
                                    {
                                        path: 'street-types',
                                        name: 'street-types',
                                        meta: {
                                            translate: (t, tc) => {
                                                return tc('master::street_types.street_type', 2).ucFirst();
                                            },
                                        },
                                        redirect: { name: 'street-types-list'},
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        children: [
                                            {
                                                path: '',
                                                name: 'street-types-list',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return tc('master::street_types.street_type', 2).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/addresses/street-types/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'street-type-create',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.create_new_item', {item: tc('master::street_types.street_type', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/addresses/street-types/item.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'street-type-edit',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.edit_item', {item: tc('master::street_types.street_type', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/addresses/street-types/item.vue')
                                            },
                                        ]
                                    },

                            // -------------------------
                            // SZEMÉLYI ATTRIBÚTUMOK
                            // -------------------------
                            {
                                path: 'personal-attributes',
                                name: 'system-master-data-personal-attributes',
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                meta: {
                                    translate: (t) => t('menu_points.system_master_data_personal_attributes').ucFirst()
                                },
                                children: [

                                    {
                                        path: "genders",
                                        name: "genders",
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        meta: {
                                            translate: (t, tc) => tc('master::genders.gender', 2).ucFirst()
                                        },
                                        redirect: {name: 'genders-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'genders-list',
                                                meta: {
                                                    translate: (t, tc) => tc('master::genders.gender', 2).ucFirst()
                                                },
                                                component: () => import('../views/pages/organizations/genders/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'gender-create',
                                                meta: {
                                                    translate: (t, tc) =>
                                                        t('base.create_new_item', {item: tc('master::genders.gender', 1)}).ucFirst()
                                                },
                                                component: () => import('../views/pages/organizations/genders/item.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'gender-edit',
                                                meta: {
                                                    translate: (t, tc) =>
                                                        t('base.edit_item', {item: tc('master::genders.gender', 1)}).ucFirst()
                                                },
                                                component: () => import('../views/pages/organizations/genders/item.vue')
                                            }
                                        ]
                                    },
                                ]
                            },

                            // -------------------------
                            // SZÁMLÁZÁSI TÖRZSADATOK
                            // -------------------------
                            {
                                path: 'billing',
                                name: 'system-master-data-billing',
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                meta: {
                                    translate: (t) => t('menu_points.system_master_data_billing').ucFirst()
                                },
                                children: [
                                    {
                                        path: 'vat',
                                        name: 'system-master-data-billing-vat',
                                        meta: {
                                            translate: (t) => t('menu_points.system_master_data_billing_vat').ucFirst()
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'vatCategories-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'vatCategories-list',
                                                meta: {
                                                    translate: (t) => t('menu_points.system_master_data_billing_vat').ucFirst()
                                                },
                                                component: () => import('../views/pages/vatCategories/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'vatCategories-vatCategory-create',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.create_new_item', {item: tc('financial::vatCategories.vatCategory', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/vatCategories/page.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'vatCategories-vatCategory-edit',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.edit_item', {item: tc('financial::vatCategories.vatCategory', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/vatCategories/page.vue')
                                            },
                                        ]
                                    },
                                    // Kuponok a Rendszer menüben: a platform-szintű kuponok (global admin),
                                    // ugyanaz a képernyő, mint a Törzsadatok alatt, a platform proppal
                                    {
                                        path: 'coupons',
                                        name: 'system-master-data-billing-coupons',
                                        meta: {
                                            translate: (t) => t('menu_points.system_master_data_billing_coupons').ucFirst()
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'system-master-data-billing-coupons-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'system-master-data-billing-coupons-list',
                                                meta: {
                                                    translate: (t) => t('menu_points.system_master_data_billing_coupons').ucFirst()
                                                },
                                                props: {platform: true},
                                                component: () => import('../views/pages/coupons/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'system-master-data-billing-coupons-create',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.create_new_item', {item: tc('financial::coupons.coupon', 1)}).ucFirst();
                                                    },
                                                },
                                                props: {platform: true},
                                                component: () => import('../views/pages/coupons/page.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'system-master-data-billing-coupons-edit',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.edit_item', {item: tc('financial::coupons.coupon', 1)}).ucFirst();
                                                    },
                                                },
                                                props: {platform: true},
                                                component: () => import('../views/pages/coupons/page.vue')
                                            },
                                            {
                                                path: ':id(\\d+)/codes',
                                                name: 'system-master-data-billing-coupons-codes',
                                                meta: {
                                                    translate: (t) => t('financial::coupons.codes.title').ucFirst(),
                                                },
                                                component: () => import('../views/pages/coupons/codes.vue')
                                            },
                                        ]
                                    },
                                    {
                                        path: 'currencies',
                                        name: 'system-master-data-billing-currencies',
                                        meta: {
                                            translate: (t) => t('menu_points.system_master_data_billing_currencies').ucFirst()
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'currencies-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'currencies-list',
                                                meta: {
                                                    translate: (t) => t('menu_points.system_master_data_billing_currencies').ucFirst()
                                                },
                                                component: () => import('../views/pages/currencies/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'currencies-currency-create',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.create_new_item', {item: tc('financial::currencies.currency', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/currencies/page.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'currencies-currency-edit',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.edit_item', {item: tc('financial::currencies.currency', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/currencies/page.vue')
                                            },
                                        ]
                                    },
                                    {
                                        path: 'units',
                                        name: 'system-master-data-billing-units',
                                        meta: {
                                            translate: (t) => t('menu_points.system_master_data_billing_units').ucFirst()
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'units-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'units-list',
                                                meta: {
                                                    translate: (t) => t('menu_points.system_master_data_billing_units').ucFirst()
                                                },
                                                component: () => import('../views/pages/units/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'units-unit-create',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.create_new_item', {item: tc('financial::units.unit', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/units/page.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'units-unit-edit',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.edit_item', {item: tc('financial::units.unit', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/units/page.vue')
                                            },
                                        ]
                                    },
                                    {
                                        path: 'payment-methods',
                                        name: 'system-master-data-billing-payment-methods',
                                        meta: {
                                            translate: (t) => t('menu_points.system_master_data_billing_payment_methods').ucFirst()
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'paymentModes-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'paymentModes-list',
                                                meta: {
                                                    translate: (t) => t('menu_points.system_master_data_billing_payment_methods').ucFirst()
                                                },
                                                component: () => import('../views/pages/paymentModes/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'paymentModes-paymentMode-create',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.create_new_item', {item: tc('financial::paymentModes.paymentMode', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/paymentModes/page.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'paymentModes-paymentMode-edit',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.edit_item', {item: tc('financial::paymentModes.paymentMode', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/paymentModes/page.vue')
                                            },
                                        ]
                                    },
                                    {
                                        path: 'health-funds',
                                        name: 'system-master-data-billing-health-funds',
                                        meta: {
                                            translate: (t) => t('menu_points.system_master_data_billing_health_funds').ucFirst()
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'healthFunds-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'healthFunds-list',
                                                meta: {
                                                    translate: (t) => t('menu_points.system_master_data_billing_health_funds').ucFirst()
                                                },
                                                component: () => import('../views/pages/healthFunds/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'healthFunds-healthFund-create',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.create_new_item', {item: tc('financial::healthFunds.healthFund', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/healthFunds/page.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'healthFunds-healthFund-edit',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.edit_item', {item: tc('financial::healthFunds.healthFund', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/healthFunds/page.vue')
                                            },
                                        ]
                                    },
                                    {
                                        path: 'health-insurances',
                                        name: 'system-master-data-billing-health-insurances',
                                        meta: {
                                            translate: (t) => t('menu_points.system_master_data_medical_health_insurances').ucFirst()
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'healthInsurances-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'healthInsurances-list',
                                                meta: {
                                                    translate: (t) => t('menu_points.system_master_data_medical_health_insurances').ucFirst()
                                                },
                                                component: () => import('../views/pages/healthInsurances/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'healthInsurances-healthInsurance-create',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.create_new_item', {item: tc('financial::healthInsurances.healthInsurance', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/healthInsurances/page.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'healthInsurances-healthInsurance-edit',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.edit_item', {item: tc('financial::healthInsurances.healthInsurance', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/healthInsurances/page.vue')
                                            },
                                        ]
                                    }
                                ]
                            },

                            // -------------------------
                            // EGÉSZSÉGÜGYI TÖRZSADATOK
                            // -------------------------
                            {
                                path: 'medical',
                                name: 'system-master-data-medical',
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                meta: {
                                    translate: (t) => t('menu_points.system_master_data_medical').ucFirst()
                                },
                                children: [
                                    {
                                        path: 'bno',
                                        name: 'system-master-data-medical-bno',
                                        meta: {
                                            translate: (t) => t('menu_points.system_master_data_medical_bno').ucFirst()
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'system-master-data-medical-bno-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'system-master-data-medical-bno-list',
                                                meta: {
                                                    translate: (t) => t('menu_points.system_master_data_medical_bno').ucFirst()
                                                },
                                                component: () => import('../views/pages/bnoCodes/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'system-master-data-medical-bno-create',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.create_new_item', {item: tc('medical::bnoCodes.bnoCode', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/bnoCodes/page.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'system-master-data-medical-bno-edit',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.edit_item', {item: tc('medical::bnoCodes.bnoCode', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/bnoCodes/page.vue')
                                            },
                                        ]
                                    },
                                    {
                                        path: 'icd-codes',
                                        name: 'system-master-data-medical-icd-codes',
                                        meta: {
                                            translate: (t) => t('menu_points.system_master_data_medical_icd-codes').ucFirst()
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'system-master-data-medical-icd-codes-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'system-master-data-medical-icd-codes-list',
                                                meta: {
                                                    translate: (t) => t('menu_points.system_master_data_medical_icd-codes').ucFirst()
                                                },
                                                component: () => import('../views/pages/icdCodes/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'system-master-data-medical-icd-codes-create',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.create_new_item', {item: tc('medical::icdCodes.icdCode', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/icdCodes/page.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'system-master-data-medical-icd-codes-edit',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.edit_item', {item: tc('medical::icdCodes.icdCode', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/icdCodes/page.vue')
                                            },
                                        ]
                                    },
                                    {
                                        path: 'cpt',
                                        name: 'system-master-data-medical-cpt',
                                        meta: {
                                            translate: (t) => t('menu_points.system_master_data_medical_cpt').ucFirst()
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'system-master-data-medical-cpt-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'system-master-data-medical-cpt-list',
                                                meta: {
                                                    translate: (t) => t('menu_points.system_master_data_medical_cpt').ucFirst()
                                                },
                                                component: () => import('../views/pages/cptCodes/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'system-master-data-medical-cpt-create',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.create_new_item', {item: tc('medical::cptCodes.cptCode', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/cptCodes/page.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'system-master-data-medical-cpt-edit',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.edit_item', {item: tc('medical::cptCodes.cptCode', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/cptCodes/page.vue')
                                            },
                                        ]
                                    },
                                    {
                                        path: 'health-funds',
                                        name: 'system-master-data-medical-health-funds',
                                        meta: {
                                            translate: (t) => t('menu_points.system_master_data_medical_health_funds').ucFirst()
                                        },
                                        component: () => import("../views/pages/empty.vue"),
                                    },
                                    {
                                        path: 'health-insurances',
                                        name: 'system-master-data-medical-health-insurances',
                                        meta: {
                                            translate: (t) => t('menu_points.system_master_data_medical_health_insurances').ucFirst()
                                        },
                                        component: () => import("../views/pages/empty.vue"),
                                    }
                                ]
                            },

                            // KÓDSZÓTÁRAK

                            {
                                path: 'dictionaries',
                                name: 'system-master-data-dictionaries',
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                meta: {
                                    translate: (t) => t('menu_points.system_master_data_dictionaries').ucFirst()
                                },
                                children: [
                                    {
                                        path: 'delete-reasons',
                                        name: 'system-master-data-dictionaries-delete-reasons',
                                        meta: {
                                            translate: (t) => t('menu_points.system_master_data_dictionaries_delete_reasons').ucFirst()
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'deleteReasons-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'deleteReasons-list',
                                                meta: {
                                                    translate: (t) => t('menu_points.system_master_data_dictionaries_delete_reasons').ucFirst()
                                                },
                                                component: () => import('../views/pages/deleteReasons/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'deleteReasons-deleteReason-create',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.create_new_item', {item: tc('medical::deleteReasons.deleteReason', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/deleteReasons/page.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'deleteReasons-deleteReason-edit',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.edit_item', {item: tc('medical::deleteReasons.deleteReason', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/deleteReasons/page.vue')
                                            },
                                        ]
                                    },
                                    {
                                        path: 'specialities',
                                        name: 'system-master-data-dictionaries-specialities',
                                        meta: {
                                            translate: (t) => t('menu_points.system_master_data_dictionaries_specialities').ucFirst()
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'system-master-data-dictionaries-specialities-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'system-master-data-dictionaries-specialities-list',
                                                meta: {
                                                    translate: (t) => t('menu_points.system_master_data_dictionaries_specialities').ucFirst()
                                                },
                                                component: () => import('../views/pages/specialties/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'system-master-data-dictionaries-specialities-create',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.create_new_item', {item: tc('medical::specialties.specialty', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/specialties/page.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'system-master-data-dictionaries-specialities-edit',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.edit_item', {item: tc('medical::specialties.specialty', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/specialties/page.vue')
                                            },
                                        ]
                                    }
                                ]
                            },

                            // -------------------------
                            // EESZT TÖRZSADATOK
                            // -------------------------
                            {
                                path: 'eeszt',
                                name: 'system-master-data-eeszt',
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                meta: {
                                    translate: (t) => t('menu_points.system_master_data_eeszt').ucFirst()
                                },
                                children: [
                                    {
                                        path: 'patient-identification-type',
                                        name: 'patient-identification-type',
                                        meta: {
                                            translate: (t) => {
                                                return t('menu_points.system_master_data_eeszt_patient_identification_type').ucFirst();
                                            },
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'patient-identification-type-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'patient-identification-type-list',
                                                meta: {
                                                    translate: (t) => {
                                                        return t('menu_points.system_master_data_eeszt_patient_identification_type').ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/torTPaciensSzonositoTips/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'patient-identification-type-create',
                                                meta: {
                                                    translate: (t) => {
                                                        return t('base.create_new_item', {item: t('menu_points.system_master_data_eeszt_patient_identification_type')}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/torTPaciensSzonositoTips/page.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'patient-identification-type-edit',
                                                meta: {
                                                    translate: (t) => {
                                                        return t('base.edit_item', {item: t('menu_points.system_master_data_eeszt_patient_identification_type')}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/torTPaciensSzonositoTips/page.vue')
                                            },
                                        ]
                                    },
                                    {
                                        path: 'bno',
                                        name: 'bno',
                                        meta: {
                                            translate: (t) => {
                                                return t('menu_points.system_master_data_eeszt_bno').ucFirst();
                                            },
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'bno-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'bno-list',
                                                meta: {
                                                    translate: (t) => {
                                                        return t('menu_points.system_master_data_eeszt_bno').ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/torBno105karakteres/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'bno-create',
                                                meta: {
                                                    translate: (t) => {
                                                        return t('base.create_new_item', {item: t('menu_points.system_master_data_eeszt_bno')}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/torBno105karakteres/page.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'bno-edit',
                                                meta: {
                                                    translate: (t) => {
                                                        return t('base.edit_item', {item: t('menu_points.system_master_data_eeszt_bno')}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/torBno105karakteres/page.vue')
                                            },
                                        ]
                                    }
                                ]
                            }
                        ]
                    },

                    // -------------------------
                    // FELHASZNÁLÓK
                    // -------------------------
                    {
                        path: 'users',
                        name: 'system-users',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.system_users').ucFirst()
                        },
                        children: [
                            {
                                path: 'nurses',
                                name: 'system-users-nurses',
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'system-users-nurses-list' },
                                meta: {
                                    translate: (t) => t('menu_points.system_users_nurses').ucFirst()
                                },
                                children: [
                                    {
                                        path: '',
                                        name: 'system-users-nurses-list',
                                        meta: {
                                            translate: (t) => t('menu_points.system_users_nurses').ucFirst()
                                        },
                                        component: () => import('../views/pages/system/users/list.vue'),
                                        props: {
                                            userType: 'staff',
                                            createRouteName: 'system-users-nurses-create',
                                            editRouteName: 'system-users-nurses-edit',
                                            titleKey: 'menu_points.system_users_nurses'
                                        }
                                    },
                                    {
                                        path: 'create',
                                        name: 'system-users-nurses-create',
                                        meta: {
                                            translate: (t, tc) => t('base.create_new_item', {item: tc('menu_points.system_users_nurses', 1)}).ucFirst()
                                        },
                                        component: () => import('../views/pages/system/users/item.vue'),
                                        props: {
                                            defaultUserType: 'staff',
                                            tenantSelectable: true,
                                            listRouteName: 'system-users-nurses-list',
                                            editRouteName: 'system-users-nurses-edit'
                                        }
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'system-users-nurses-edit',
                                        meta: {
                                            translate: (t, tc) => t('base.edit_item', {item: tc('menu_points.system_users_nurses', 1)}).ucFirst()
                                        },
                                        component: () => import('../views/pages/system/users/item.vue'),
                                        props: {
                                            listRouteName: 'system-users-nurses-list',
                                            editRouteName: 'system-users-nurses-edit'
                                        }
                                    },
                                ]
                            },
                            {
                                path: 'doctors',
                                name: 'system-users-doctors',
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'system-users-doctors-list' },
                                meta: {
                                    translate: (t) => t('menu_points.system_users_doctors').ucFirst()
                                },
                                children: [
                                    {
                                        path: '',
                                        name: 'system-users-doctors-list',
                                        meta: {
                                            translate: (t) => t('menu_points.system_users_doctors').ucFirst()
                                        },
                                        component: () => import('../views/pages/system/users/list.vue'),
                                        props: {
                                            userType: 'medical',
                                            createRouteName: 'system-users-doctors-create',
                                            editRouteName: 'system-users-doctors-edit',
                                            titleKey: 'menu_points.system_users_doctors'
                                        }
                                    },
                                    {
                                        path: 'create',
                                        name: 'system-users-doctors-create',
                                        meta: {
                                            translate: (t, tc) => t('base.create_new_item', {item: tc('menu_points.system_users_doctors', 1)}).ucFirst()
                                        },
                                        component: () => import('../views/pages/system/users/item.vue'),
                                        props: {
                                            defaultUserType: 'medical',
                                            tenantSelectable: true,
                                            listRouteName: 'system-users-doctors-list',
                                            editRouteName: 'system-users-doctors-edit'
                                        }
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'system-users-doctors-edit',
                                        meta: {
                                            translate: (t, tc) => t('base.edit_item', {item: tc('menu_points.system_users_doctors', 1)}).ucFirst()
                                        },
                                        component: () => import('../views/pages/system/users/item.vue'),
                                        props: {
                                            listRouteName: 'system-users-doctors-list',
                                            editRouteName: 'system-users-doctors-edit'
                                        }
                                    },
                                ]
                            },
                            {
                                path: 'users',
                                name: 'users',
                                meta: {
                                    translate: (t, tc) => {
                                        return tc('users.user', 2).ucFirst();
                                    },
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'users-list'},
                                children: [
                                    {
                                        path: '',
                                        name: 'users-list',
                                        meta: {
                                            translate: (t, tc) => {
                                                return tc('users.user', 2).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/system/users/list.vue'),
                                        props: {
                                            createRouteName: 'user-create',
                                            editRouteName: 'user-edit',
                                            titleKey: 'menu_points.system_users_users'
                                        }
                                    },
                                    {
                                        path: 'create',
                                        name: 'user-create',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.create_new_item', {item: tc('users.user', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/system/users/item.vue'),
                                        props: {
                                            defaultUserType: 'regular',
                                            tenantSelectable: true,
                                            listRouteName: 'users-list',
                                            editRouteName: 'user-edit'
                                        }
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'user-edit',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.edit_item', {item: tc('users.user', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/system/users/item.vue'),
                                        props: {
                                            tenantSelectable: true,
                                            listRouteName: 'users-list',
                                            editRouteName: 'user-edit'
                                        }
                                    },
                                ]
                            },
                            {
                                path: 'impersonations',
                                name: 'system-users-impersonations',
                                meta: {
                                    translate: (t) => t('menu_points.system_users_impersonations').ucFirst(),
                                },
                                component: () => import('../views/pages/system/users/impersonations.vue'),
                            },
                            {
                                path: 'tenant-entries',
                                name: 'system-users-tenant-entries',
                                meta: {
                                    translate: (t) => t('menu_points.system_users_tenant_entries').ucFirst(),
                                },
                                component: () => import('../views/pages/system/users/tenant-entries.vue'),
                            },
                        ]
                    },

                    // -------------------------
                    // INTÉZMÉNYEK
                    // -------------------------
                    {
                        path: 'institutions',
                        name: 'system-institutions',
                        meta: {
                            translate: (t) => t('menu_points.system_institutions').ucFirst(),
                        },
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        redirect: { name: 'system-tenants-list'},
                        children: [
                            {
                                path: '',
                                name: 'system-tenants-list',
                                props: { isGlobal: true },
                                meta: {
                                    translate: (t, tc) => tc('system::tenants.tenant', 2).ucFirst()
                                },
                                component: () => import('../views/pages/system/tenants/list.vue')
                            },
                            {
                                path: 'create',
                                name: 'system-tenant-create',
                                props: { isGlobal: true },
                                meta: {
                                    translate: (t, tc) => t('base.create_new_item', {item: tc('system::tenants.tenant', 1)}).ucFirst()
                                },
                                component: () => import('../views/pages/system/tenants/page.vue')
                            },
                            {
                                path: ':id(\\d+)',
                                name: 'system-tenant-edit',
                                props: { isGlobal: true },
                                meta: {
                                    translate: (t, tc) => t('base.edit_item', {item: tc('system::tenants.tenant', 1)}).ucFirst()
                                },
                                component: () => import('../views/pages/system/tenants/page.vue')
                            },
                        ]
                    },

                    // -------------------------
                    // APPLIKÁCIÓK
                    // -------------------------
                    {
                        path: 'applications',
                        name: 'system-applications',
                        meta: {
                            translate: (t) => t('menu_points.system_applications').ucFirst(),
                        },
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        redirect: { name: 'system-applications-list'},
                        children: [
                            {
                                path: '',
                                name: 'system-applications-list',
                                props: { isGlobal: true },
                                meta: {
                                    translate: (t, tc) => tc('system::applications.application', 2).ucFirst()
                                },
                                component: () => import('../views/pages/applications/list.vue')
                            },
                            {
                                path: 'create',
                                name: 'system-application-create',
                                props: { isGlobal: true },
                                meta: {
                                    translate: (t, tc) => t('base.create_new_item', {item: tc('system::applications.application', 1)}).ucFirst()
                                },
                                component: () => import('../views/pages/applications/page.vue')
                            },
                            {
                                path: ':id(\\d+)',
                                name: 'system-application-edit',
                                props: { isGlobal: true },
                                meta: {
                                    translate: (t, tc) => t('base.edit_item', {item: tc('system::applications.application', 1)}).ucFirst()
                                },
                                component: () => import('../views/pages/applications/page.vue')
                            },
                        ]
                    },

                    // -------------------------
                    // ELSZÁMOLÓHÁZ (elvégzett szolgáltatások, számlák; F6: online fizetések)
                    // -------------------------
                    {
                        path: 'clearing-house',
                        name: 'system-clearing-house',
                        meta: {
                            // intézményi adatot mutató Rendszer-lista: belépve, Global állásban olvasva minden intézményé, írva a belépetté
                            tenantData: true,
                            translate: (t) => t('menu_points.system_clearing_house').ucFirst()
                        },
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        redirect: { name: 'used-services-list' },
                        children: [
                            {
                                path: 'used-services',
                                name: 'system-clearing-house-used-services',
                                meta: {
                                    translate: (t) => t('menu_points.system_clearing_house_used_services').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'used-services-list' },
                                children: [
                                    {
                                        path: '',
                                        name: 'used-services-list',
                                        meta: {
                                            translate: (t) => t('menu_points.system_clearing_house_used_services').ucFirst()
                                        },
                                        component: () => import('../views/pages/usedServices/list.vue')
                                    },
                                ]
                            },
                            {
                                path: 'invoices',
                                name: 'system-clearing-house-invoices',
                                meta: {
                                    translate: (t) => t('menu_points.system_clearing_house_invoices').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'invoices-list' },
                                children: [
                                    {
                                        path: '',
                                        name: 'invoices-list',
                                        meta: {
                                            translate: (t) => t('menu_points.system_clearing_house_invoices').ucFirst()
                                        },
                                        component: () => import('../views/pages/invoices/list.vue')
                                    },
                                ]
                            },
                            {
                                path: 'payments',
                                name: 'system-clearing-house-payments',
                                meta: {
                                    translate: (t) => t('menu_points.system_clearing_house_payments').ucFirst()
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'payments-list' },
                                children: [
                                    {
                                        path: '',
                                        name: 'payments-list',
                                        meta: {
                                            translate: (t) => t('menu_points.system_clearing_house_payments').ucFirst()
                                        },
                                        component: () => import('../views/pages/payments/list.vue')
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'payments-payment-show',
                                        meta: {
                                            translate: (t) => t('financial::payments.detail.title').ucFirst()
                                        },
                                        component: () => import('../views/pages/payments/page.vue')
                                    },
                                ]
                            },
                        ]
                    },

                    // -------------------------
                    // RIPORTOK
                    // -------------------------
                    {
                        path: 'reports',
                        name: 'system-reports',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.system_reports').ucFirst()
                        },
                        redirect: { name: 'system-reports-activity' },
                        children: [
                            {
                                path: 'activity',
                                name: 'system-reports-activity',
                                meta: {
                                    translate: (t) => t('menu_points.system_reports_activity').ucFirst()
                                },
                                component: () => import('../views/pages/reports/activity.vue'),
                            },
                            {
                                path: 'feedback',
                                name: 'system-reports-feedback',
                                meta: {
                                    translate: (t) => t('menu_points.system_reports_feedback').ucFirst()
                                },
                                component: () => import('../views/pages/reports/feedback.vue'),
                            },
                            {
                                path: 'cancellations',
                                name: 'system-reports-cancellations',
                                meta: {
                                    translate: (t) => t('menu_points.system_reports_cancellations').ucFirst()
                                },
                                component: () => import('../views/pages/reports/cancellations.vue'),
                            },
                        ],
                    },

                    // -------------------------
                    // RENDSZERÜZENETEK
                    // -------------------------
                    {
                        path: 'messages',
                        name: 'system-messages',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.system_messages').ucFirst()
                        },
                        children: [
                            {
                                path: 'messages',
                                name: 'system-messages-messages',
                                meta: {
                                    translate: (t) => t('menu_points.system_messages_messages').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            }
                        ]
                    },

                    // -------------------------
                    // JOGOSULTSÁGKEZELÉS
                    // -------------------------
                    {
                        path: 'authorization',
                        name: 'system-authorization',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.system_authorization').ucFirst()
                        },
                        children: [

                            // Authorization structure
                            {
                                path: 'authorization-structure',
                                name: 'system-authorization-structure',
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                meta: {
                                    translate: (t) => t('menu_points.system_authorization_structure').ucFirst()
                                },
                                children: [
                                    // ----------------------------------------------------
                                    //                     PERMISSIONS
                                    // ----------------------------------------------------
                                    {
                                        path: 'permissions',
                                        name: 'permissions',
                                        meta: {
                                            translate: (t, tc) => tc('authorization::roles.role', 2).ucFirst(),
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'permissions-list' },
                                        children: [
                                            {
                                                path: '',
                                                name: 'permissions-list',
                                                meta: {
                                                    translate: (t, tc) => tc('authorization::roles.role', 2).ucFirst(),
                                                },
                                                component: () => import('../views/pages/system/authorization/roles/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'permission-create',
                                                meta: {
                                                    translate: (t, tc) => t('base.create_new_item', { item: tc('authorization::roles.role', 1) }).ucFirst(),
                                                },
                                                component: () => import('../views/pages/system/authorization/roles/item.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'permission-edit',
                                                meta: {
                                                    translate: (t, tc) =>
                                                        t('base.edit_item', { item: tc('authorization::roles.role', 1) }).ucFirst(),
                                                },
                                                component: () => import('../views/pages/system/authorization/roles/item.vue')
                                            },
                                        ]
                                    },

                                    // ----------------------------------------------------
                                    //                   ROLE GROUPS
                                    // ----------------------------------------------------
                                    {
                                        path: 'role-groups',
                                        name: 'role-groups',
                                        meta: {
                                            translate: (t, tc) => tc('authorization::role_groups.role_group', 2).ucFirst(),
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'role-groups-list' },
                                        children: [
                                            {
                                                path: '',
                                                name: 'role-groups-list',
                                                meta: {
                                                    translate: (t, tc) => tc('authorization::role_groups.role_group', 2).ucFirst(),
                                                },
                                                component: () => import('../views/pages/system/authorization/role-groups/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'role-group-create',
                                                meta: {
                                                    translate: (t, tc) =>
                                                        t('base.create_new_item', { item: tc('authorization::role_groups.role_group', 1) }).ucFirst(),
                                                },
                                                component: () => import('../views/pages/system/authorization/role-groups/item.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'role-group-edit',
                                                meta: {
                                                    translate: (t, tc) =>
                                                        t('base.edit_item', { item: tc('authorization::role_groups.role_group', 1) }).ucFirst(),
                                                },
                                                component: () => import('../views/pages/system/authorization/role-groups/item.vue')
                                            },
                                        ]
                                    },

                                    // ----------------------------------------------------
                                    //                 ROLE CATEGORIES
                                    // ----------------------------------------------------
                                    {
                                        path: 'role-categories',
                                        name: 'role-categories',
                                        meta: {
                                            translate: (t, tc) => tc('authorization::role_categories.role_category', 2).ucFirst(),
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'role-categories-list' },
                                        children: [
                                            {
                                                path: '',
                                                name: 'role-categories-list',
                                                meta: {
                                                    translate: (t, tc) => tc('authorization::role_categories.role_category', 2).ucFirst(),
                                                },
                                                component: () => import('../views/pages/system/authorization/role-categories/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'role-category-create',
                                                meta: {
                                                    translate: (t, tc) =>
                                                        t('base.create_new_item', { item: tc('authorization::role_categories.role_category', 1) }).ucFirst(),
                                                },
                                                component: () => import('../views/pages/system/authorization/role-categories/item.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'role-category-edit',
                                                meta: {
                                                    translate: (t, tc) =>
                                                        t('base.edit_item', { item: tc('authorization::role_categories.role_category', 1) }).ucFirst(),
                                                },
                                                component: () => import('../views/pages/system/authorization/role-categories/item.vue')
                                            },
                                        ]
                                    },

                                    // ----------------------------------------------------
                                    //                       MODULES
                                    // ----------------------------------------------------
                                    {
                                        path: 'modules',
                                        name: 'modules',
                                        meta: {
                                            translate: (t, tc) => tc('authorization::modules.module', 2).ucFirst(),
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'modules-list' },
                                        children: [
                                            {
                                                path: '',
                                                name: 'modules-list',
                                                meta: {
                                                    translate: (t, tc) => tc('authorization::modules.module', 2).ucFirst(),
                                                },
                                                component: () => import('../views/pages/system/authorization/modules/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'module-create',
                                                meta: {
                                                    translate: (t, tc) =>
                                                        t('base.create_new_item', { item: tc('authorization::modules.module', 1) }).ucFirst(),
                                                },
                                                component: () => import('../views/pages/system/authorization/modules/item.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'module-edit',
                                                meta: {
                                                    translate: (t, tc) =>
                                                        t('base.edit_item', { item: tc('authorization::modules.module', 1) }).ucFirst(),
                                                },
                                                component: () => import('../views/pages/system/authorization/modules/item.vue')
                                            },
                                        ]
                                    },
                                ]
                            }
                        ]
                    },

                    // -------------------------
                    // MENÜSTRUKTÚRA
                    // -------------------------
                    {
                        path: 'menu-system',
                        name: 'menu-system',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.menu_system').ucFirst()
                        },
                        children: [
                            // ----------------------------------------------------
                            //                     MENÜK
                            // ----------------------------------------------------
                            {
                                path: 'menus',
                                name: 'menus',
                                meta: {
                                    translate: (t, tc) => tc('menus::menus.menu', 2).ucFirst(),
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'menus-list' },
                                children: [
                                    {
                                        path: '',
                                        name: 'menus-list',
                                        meta: {
                                            translate: (t, tc) => tc('menus::menus.menu', 2).ucFirst(),
                                        },
                                        component: () => import('../views/pages/system/menus/menus/list.vue')
                                    },
                                    {
                                        path: 'create',
                                        name: 'menu-create',
                                        meta: {
                                            translate: (t, tc) => t('base.create_new_item', { item: tc('menus::menus.menu', 1) }).ucFirst(),
                                        },
                                        component: () => import('../views/pages/system/menus/menus/item.vue')
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'menu-edit',
                                        meta: {
                                            translate: (t, tc) =>
                                                t('base.edit_item', { item: tc('menus::menus.menu', 1) }).ucFirst(),
                                        },
                                        component: () => import('../views/pages/system/menus/menus/item.vue')
                                    },
                                ]
                            },

                            // ----------------------------------------------------
                            //                   MENÜPONTKATEGÓRIÁK
                            // ----------------------------------------------------
                            {
                                path: 'menu-point-categories',
                                name: 'menu-point-categories',
                                meta: {
                                    translate: (t, tc) => tc('menus::menu_point_categories.menu-point-category', 2).ucFirst(),
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'menu-point-categories-list' },
                                children: [
                                    {
                                        path: '',
                                        name: 'menu-point-categories-list',
                                        meta: {
                                            translate: (t, tc) => tc('menus::menu_point_categories.menu-point-category', 2).ucFirst(),
                                        },
                                        component: () => import('../views/pages/system/menus/menu-point-categories/list.vue')
                                    },
                                    {
                                        path: 'create',
                                        name: 'menu-point-category-create',
                                        meta: {
                                            translate: (t, tc) =>
                                                t('base.create_new_item', { item: tc('menus::menu_point_categories.menu-point-category', 1) }).ucFirst(),
                                        },
                                        component: () => import('../views/pages/system/menus/menu-point-categories/item.vue')
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'menu-point-category-edit',
                                        meta: {
                                            translate: (t, tc) =>
                                                t('base.edit_item', { item: tc('menus::menu_point_categories.menu-point-category', 1) }).ucFirst(),
                                        },
                                        component: () => import('../views/pages/system/menus/menu-point-categories/item.vue')
                                    },
                                ]
                            },

                            // ----------------------------------------------------
                            //                 MENÜPONTOK
                            // ----------------------------------------------------
                            {
                                path: 'menu-points',
                                name: 'menu-points',
                                meta: {
                                    translate: (t, tc) => tc('menus::menu_points.menu_point', 2).ucFirst(),
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'menu-points-list' },
                                children: [
                                    {
                                        path: '',
                                        name: 'menu-points-list',
                                        meta: {
                                            translate: (t, tc) => tc('menus::menu_points.menu_point', 2).ucFirst(),
                                        },
                                        component: () => import('../views/pages/system/menus/menu-points/list.vue')
                                    },
                                    {
                                        path: 'create',
                                        name: 'menu-point-create',
                                        meta: {
                                            translate: (t, tc) =>
                                                t('base.create_new_item', { item: tc('menus::menu_points.menu_point', 1) }).ucFirst(),
                                        },
                                        component: () => import('../views/pages/system/menus/menu-points/item.vue')
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'menu-point-edit',
                                        meta: {
                                            translate: (t, tc) =>
                                                t('base.edit_item', { item: tc('menus::menu_points.menu_point', 1) }).ucFirst(),
                                        },
                                        component: () => import('../views/pages/system/menus/menu-points/item.vue')
                                    },
                                ]
                            },
                        ]
                    },

                    // ----------------------------------------------------
                    //                       MODULES
                    // ----------------------------------------------------
                    {
                        path: 'modules',
                        name: 'modules',
                        meta: {
                            translate: (t, tc) => tc('authorization::modules.module', 2).ucFirst(),
                        },
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        redirect: { name: 'modules-list' },
                        children: [
                            {
                                path: '',
                                name: 'modules-list',
                                meta: {
                                    translate: (t, tc) => tc('authorization::modules.module', 2).ucFirst(),
                                },
                                component: () => import('../views/pages/system/authorization/modules/list.vue')
                            },
                            {
                                path: 'create',
                                name: 'module-create',
                                meta: {
                                    translate: (t, tc) =>
                                        t('base.create_new_item', { item: tc('authorization::modules.module', 1) }).ucFirst(),
                                },
                                component: () => import('../views/pages/system/authorization/modules/item.vue')
                            },
                            {
                                path: ':id(\\d+)',
                                name: 'module-edit',
                                meta: {
                                    translate: (t, tc) =>
                                        t('base.edit_item', { item: tc('authorization::modules.module', 1) }).ucFirst(),
                                },
                                component: () => import('../views/pages/system/authorization/modules/item.vue')
                            },
                        ]
                    },

                    // -------------------------
                    // RENDSZERFELÜGYELET
                    // -------------------------

                    {
                        path: 'resource-monitor',
                        name: 'system-resource-monitor',
                        meta: {
                            translate: (t) => t('menu_points.system_resource_monitor').ucFirst()
                        },
                        component: () => import('../views/pages/system/resource-monitor.vue')
                    },
                ]
            },
        ]
    },
    {
        // Belépés a Globalixból: a token a címben érkezik, az oldal beváltja, és a
        // kezdőlapra visz. Bejelentkezés nélkül nyitható (nincs `authRequired`).
        path: "/sso/globalix",
        name: "sso-globalix",
        component: () => import("../views/pages/account/sso-globalix"),
    },
    {
        // A Globalixba ágyazott keret belépése (#273, `utils/embed.js`): a beváltás után a token
        // menüpontjára visz. Bejelentkezés nélkül nyitható (nincs `authRequired`).
        path: "/embed/sso/globalix",
        name: "sso-globalix-embed",
        component: () => import("../views/pages/account/sso-globalix-embed"),
    },
    {
        // A keret lejárt munkamenete: belépő oldal helyett ez, a Globalix nyitja újra.
        path: "/embed/expired",
        name: "embed-expired",
        component: () => import("../views/pages/account/embed-expired"),
    },
    {
        path: "/login",
        name: "login",
        component: () => import("../views/pages/account/login"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({name: "home"});
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },

    {
        path: "/register",
        name: "Register",
        component: () => import("../views/pages/account/register"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({name: "home"});
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    {
        path: "/forgot-password",
        name: "Forgot password",
        component: () => import("../views/pages/account/forgot-password"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({name: "home"});
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },

    {
        // A kiküldött jelszó-beállító link CÉLJA. Az útvonalat a szerver építi
        // (`spa.pass_reset_url` + a token), az e-mail címet pedig a query hozza: egy
        // ÚJ kolléga böngészőjében nincs honnan tudni, a felület máskor a saját
        // tárolójából venné, oda viszont csak akkor kerül, ha ő maga kérte a linket
        // ugyanabban a böngészőben.
        path: "/auth/reset/:token",
        name: "reset-password",
        component: () => import("../views/pages/account/reset-password"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                if (store.getters["auth/loggedIn"]) {
                    next({name: "home"});
                } else {
                    next();
                }
            },
        },
    },

    {
        path: "/error/404-basic",
        name: "error-404-basic",
        meta: {
            authRequired: true,
        },
        component: () => import("../views/pages/errors/404-basic"),
    },
    {
        path: "/error/404-cover",
        name: "error-404-cover",
        meta: {
            authRequired: true,
        },
        component: () => import("../views/pages/errors/404-cover"),
    },
    {
        path: "/error/500-basic",
        name: "error-500-basic",
        meta: {
            authRequired: true,
        },
        component: () => import("../views/pages/errors/500-basic"),
    },
    {
        path: "/error/500-cover",
        name: "error-500-cover",
        meta: {
            authRequired: true,
        },
        component: () => import("../views/pages/errors/500-cover"),
    },
];
